// Tipos y constantes compartidas entre apps/web y functions.

export type UserRole = "platform_admin" | "tenant_admin" | "ambassador" | "customer";

export type AuthClaims = {
  tenantId?: string;
  role?: UserRole;
};

export type BusinessType =
  | "cafeteria"
  | "restaurant"
  | "panaderia"
  | "bar"
  | "heladeria"
  | "tienda_alimentos"
  | "minimarket"
  | "carniceria"
  | "fruteria"
  | "rotiseria"
  | "delivery_dark_kitchen"
  | "food_truck"
  | "tienda_ropa"
  | "tienda_belleza"
  | "peluqueria"
  | "barberia"
  | "spa"
  | "gimnasio"
  | "yoga_pilates"
  | "lavanderia"
  | "veterinaria"
  | "petshop"
  | "libreria"
  | "florista"
  | "decohogar"
  | "ferreteria"
  | "tienda_tecnologia"
  | "otro";

export const BUSINESS_TYPES: { id: BusinessType; label: string }[] = [
  { id: "cafeteria", label: "Cafetería" },
  { id: "restaurant", label: "Restaurante" },
  { id: "panaderia", label: "Panadería / Pastelería" },
  { id: "bar", label: "Bar / Coctelería" },
  { id: "heladeria", label: "Heladería" },
  { id: "tienda_alimentos", label: "Tienda de alimentos" },
  { id: "minimarket", label: "Minimarket / Almacén" },
  { id: "carniceria", label: "Carnicería" },
  { id: "fruteria", label: "Frutería / Verdulería" },
  { id: "rotiseria", label: "Rotisería / Comida preparada" },
  { id: "delivery_dark_kitchen", label: "Delivery / Dark kitchen" },
  { id: "food_truck", label: "Food truck / pop-up" },
  { id: "tienda_ropa", label: "Tienda de ropa" },
  { id: "tienda_belleza", label: "Tienda de belleza / Cosmética" },
  { id: "peluqueria", label: "Peluquería" },
  { id: "barberia", label: "Barbería" },
  { id: "spa", label: "Spa / Masajes" },
  { id: "gimnasio", label: "Gimnasio / CrossFit" },
  { id: "yoga_pilates", label: "Yoga / Pilates / Bienestar" },
  { id: "lavanderia", label: "Lavandería / Tintorería" },
  { id: "veterinaria", label: "Veterinaria" },
  { id: "petshop", label: "Petshop" },
  { id: "libreria", label: "Librería" },
  { id: "florista", label: "Florería" },
  { id: "decohogar", label: "Decoración / Hogar" },
  { id: "ferreteria", label: "Ferretería" },
  { id: "tienda_tecnologia", label: "Tecnología / Electrónica" },
  { id: "otro", label: "Otro" }
];

export type LocationsRange = "1" | "2-5" | "6+";

export * from "./taxId.js";
